import React, { Component } from 'react';
import { connect } from "react-redux";
import { getIsNameFieldDisabled } from '../../../selectors/reservation';
import Address from '@showclix-shared/CheckoutProcess/components/Address';
import { DELIVERY_TYPE_POST } from '@checkout-v/delivery/reducers/delivery';
import { hasDeliverableProducts } from '@checkout-b/checkout/selectors/product';

class ConnectedAddress extends Component<Props> {
    render() {
        const props = {...this.props};

        const { region: browserBasedCountry } = new Intl.Locale(navigator.language);

        if (!props.countryCode && !!this.props.defaultCountryCode) {
            props.countryCode = this.props.defaultCountryCode;
        }
        if (!props.country) {
            // In some cases, reservation.country = "", so let's try to take customer's location based on browser locale.
            props.country = this.props.defaultCountry ? this.props.defaultCountry : browserBasedCountry
        }

        return <Address {...props} />
    }
}

const mapStateToProps = state => {
    const reservation = state.reservation;
    const deliveryOptions = state.delivery.options;
    const deliveryOption = deliveryOptions.find((option) => option.id === reservation.selected_delivery_option) || { method_name: null };
    const isPhoneRequired =
      state.weather?.quote?.selected ||
      deliveryOption.method_type === DELIVERY_TYPE_POST ||
      state.reservation?.hasPhoneRequired ||
      hasDeliverableProducts(state);

    return {
        defaultCountryCode: state.reservation.country_phone_code,
        defaultCountry: state.reservation.country,
        nameDisabled: getIsNameFieldDisabled(state),
        phoneRequired: isPhoneRequired,
    }
}

export default connect(mapStateToProps)(ConnectedAddress);
